import React from 'react';
import RowWrapper from './RowWrapper';

export interface Props {
  width: number;
  children: React.ReactNode;
}

const TorpedoContentStrip: React.FC<Props> = ({ children, width }) => {
  return (
    <RowWrapper
      style={{
        width,
      }}
    >
      {children}
    </RowWrapper>
  );
};
TorpedoContentStrip.displayName = 'TorpedoContentStrip';

export default React.memo(TorpedoContentStrip);
